import React from "react";
import { Modal, Button, Table } from "semantic-ui-react";

export const getReportComparison = (props) => (
  <Modal
    className={"dialog-report-comparison"}
    trigger={
      <span
        role={"link"}
        tabIndex={-20}
        onClick={() => props.openDialog()}
        className="text-center mvrHref"
      >
        Click here for full report comparison
      </span>
    }
    closeIcon
    open={props.active}
    onClose={() => props.closeDialog(this)}
  >
    <Modal.Header>Report Options</Modal.Header>
    <Modal.Content image scrolling>
      <div id="selectionsContainer" className="report_selections noPrint">
        <Table className="no-border">
          <Table.Body>
            <Table.Row>
              <Table.Cell width={6} className="border-right">
                <Table className="no-border report-name-header text-center">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>Gold Report</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <div>
                  <table className="report_detail">
                    <tbody>
                      <tr>
                        <td colSpan="2" className="text-center padding-10">
                          <span className="report-compare-sub-title">
                            Your Report Includes When Available...
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <table className="rpt_dtl_left">
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Name</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Alias Names</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Date of Birth</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    SSN <font color="red">(if available)</font>
                                  </li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>SSN Verification</li>
                                      <li>SSN State Of Issue</li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Death Records</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Current Address</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Address History</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ lineHeight: "15px" }}>
                                    Demographic Information
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Census Information</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Counties</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Phone Numbers</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Phone Carriers</li>
                                </ul>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Common Residency</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Neighbors</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Relatives</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Property - Real Estate</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Property - Values</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Emails</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li> Social Media</li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>Facebook</li>
                                      <li>LinkedIn</li>
                                      <li>Google+</li>
                                      <li>Twitter</li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Table.Cell>
              <Table.Cell width={10}>
                <Table className="no-border report-name-header text-center">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>Platinum Report</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <div>
                  <table className="report_detail">
                    <tbody>
                      <tr>
                        <td colSpan="2" className="text-center padding-10">
                          <span className="report-compare-sub-title">
                            Your Report Includes When Available...
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table
                            className="rpt_dtl_left"
                            style={{ verticalAlign: "top" }}
                          >
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Name</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Alias Names</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Imposters</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Date Of Birth</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Age</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    SSN <font color="red">(if available)</font>
                                  </li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>SSN Verification</li>
                                      <li>SSN State Of Issue</li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Death Records</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Current Address</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Address History</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ lineHeight: "15px" }}>
                                    Demographic Information
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Census Information</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Counties</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Phone Numbers</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Phone Carriers</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Common Residency
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Neighbors - Current
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Neighbors - Historical
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>Up to 10</li>
                                      <li>6 Neighbors/Address</li>
                                      <li style={{ lineHeight: "15px" }}>
                                        Contact Information
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Relatives{" "}
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>3 Degrees of Separation</li>
                                      <li>Relative Contact Info</li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table className="rpt_dtl_right">
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Corporate Affiliations</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ whitespace: "no-wrap" }}>
                                    Property - Real Estate
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Property Values</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Professional Licenses
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Bankruptcies</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ lineHeight: "15px" }}>
                                    Liens and Judgments
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Foreclosures</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>UCC Filings</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Criminal Records
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>
                                    Sexual Offenses
                                    <span className="reportSelectionHighlight">
                                      *
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Emails</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li> Social Media</li>
                                  <li className="noBullet">
                                    <ul className="rptDtlSubLevel">
                                      <li>Facebook</li>
                                      <li>LinkedIn</li>
                                      <li>Google+</li>
                                      <li>Twitter</li>
                                    </ul>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Watercraft</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>FAA Aircraft</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>FAA Certifications</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Voter Registration</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ lineHeight: "15px" }}>
                                    Federal Firearms &amp; Explosives
                                  </li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Hunting/Fishing</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>People At Work</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li>Associates</li>
                                </ul>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <ul className="rptDtlTopLevel">
                                  <li style={{ lineHeight: "15px" }}>
                                    Concealed Weapons Permits
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" className="text-center">
                          <span className="reportSelectionHighlight">*</span>
                          <span> Indicates Premium Data Sources</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        {/* <div
          className="float-left roundedCorners10 box-shadow newReportSelectionContainer"
          style={{ marginLeft: "70px", minHeight: "565px" }}
        >
          <div className="newReportSelectionContainerHeader roundedTopCorners result-comparison-sub-header">
            Gold Report
          </div>

          <div style={{ minHeight: "609px" }}>
            <table className="report_detail">
              <tr>
                <td colSpan="2" className="text-center">
                  <span className="report-compare-sub-title">&nbsp;</span>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="text-center">
                  <span className="report-compare-sub-title">
                    Your Report Includes When Available...
                  </span>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="text-center">
                  <span className="report-compare-sub-title">&nbsp;</span>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <table className="rpt_dtl_left">
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Name</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Alias Names</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Date of Birth</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            SSN <font color="red">(if available)</font>
                          </li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>SSN Verification</li>
                              <li>SSN State Of Issue</li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Death Records</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Current Address</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Address History</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ lineHeight: "15px;" }}>
                            Demographic Information
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Census Information</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Counties</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Phone Numbers</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Phone Carriers</li>
                        </ul>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Common Residency</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Neighbors</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Relatives</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Property - Real Estate</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Property - Values</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Emails</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li> Social Media</li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>Facebook</li>
                              <li>LinkedIn</li>
                              <li>Google+</li>
                              <li>Twitter</li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="float-right roundedCorners10 box-shadow newReportSelectionContainer report-compare-platinum-sub-title">
          <div className="newReportSelectionContainerHeader roundedTopCorners result-comparison-sub-header">
            Platinum Report
          </div>

          <div style={{ minHeight: "609px" }}>
            <table className="report_detail">
              <tr>
              <td colSpan="2" className="text-center">
                <span className="report-compare-sub-title">&nbsp;</span>
              </td>
              </tr>
              <tr>
                <td colSpan="2" className="text-center">
                  <span className="report-compare-sub-title">
                    Your Report Includes When Available...
                  </span>
                </td>
              </tr>
              <td colSpan="2" className="text-center">
                <span className="report-compare-sub-title">&nbsp;</span>
              </td>
              <tr>
                <td style={{ width: "50%" }}>
                  <table className="rpt_dtl_left">
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Name</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Alias Names</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Imposters</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Date Of Birth</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Age</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            SSN <font color="red">(if available)</font>
                          </li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>SSN Verification</li>
                              <li>SSN State Of Issue</li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Death Records</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Current Address</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Address History</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ lineHeight: "15px;" }}>
                            Demographic Information
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Census Information</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Counties</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Phone Numbers</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Phone Carriers</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Common Residency
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Neighbors - Current
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Neighbors - Historical
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>Up to 10</li>
                              <li>6 Neighbors/Address</li>
                              <li style={{ lineHeight: "15px" }}>
                                Contact Information
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Relatives{" "}
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>3 Degrees of Separation</li>
                              <li>Relative Contact Info</li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table className="rpt_dtl_right">
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Corporate Affiliations</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ whitespace: "no-wrap" }}>
                            Property - Real Estate
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Property Values</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Professional Licenses
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Bankruptcies</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ lineHeight: "15px" }}>
                            Liens and Judgments
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Foreclosures</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>UCC Filings</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Criminal Records
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>
                            Sexual Offenses
                            <span className="reportSelectionHighlight">*</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Emails</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li> Social Media</li>
                          <li className="noBullet">
                            <ul className="rptDtlSubLevel">
                              <li>Facebook</li>
                              <li>LinkedIn</li>
                              <li>Google+</li>
                              <li>Twitter</li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Watercraft</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>FAA Aircraft</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>FAA Certifications</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Voter Registration</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ lineHeight: "15px" }}>
                            Federal Firearms &amp; Explosives
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Hunting/Fishing</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>People At Work</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li>Associates</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="rptDtlTopLevel">
                          <li style={{ lineHeight: "15px" }}>
                            Concealed Weapons Permits
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="text-center">
                  <span className="reportSelectionHighlight">*</span>
                  <span> Indicates Premium Data Sources</span>
                </td>
              </tr>
            </table>
          </div>
        </div> */}
      </div>
    </Modal.Content>
    <Modal.Actions className={"dialog-actions"}>
      <Button
        className={"no-background-color float-right"}
        onClick={() => props.closeDialog(this)}
      >
        Done
      </Button>
    </Modal.Actions>
  </Modal>
);

export default getReportComparison;



// WEBPACK FOOTER //
// ./src/components/dialogs/ReportComparison.js